import url from './url';
import request from './request';

import { LocalStorage } from '~/helpers';
import { MessageType } from '~/constants';

export const getTemplates = async ({
  limit,
  offset,
  type,
  order = null,
  sort = null,
  search = null,
}) => {
  const params = new URLSearchParams({
    limit,
    offset,
    ...(search !== null && { search }),
    ...(order !== null && { order }),
    ...(sort !== null && { sort }),
    ...(type && { type }),
  });

  return request(`${url.templates}?${params.toString()}`, {
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
      'Cache-Control': 'no-cache',
    },
  });
};

export const createTemplate = async (rawPayload) => {
  const payload = { ...rawPayload };

  if (payload.media === null) {
    delete payload.media;
  }

  if (payload.suggestions?.length === 0) {
    delete payload.suggestions;
  }

  return request(`${url.templates}`, {
    method: 'POST',
    data: payload,
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
      'Cache-Control': 'no-cache',
    },
  });
};

export const deleteTemplate = (template_id) =>
  request(`${url.templates}/${template_id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
      'Cache-Control': 'no-cache',
    },
  });

export const sendTemplate = async ({
  agentID,
  templateID,
  customerNumber,
  bodyVariables = null,
  headerVariables = null,
}) => {
  const payload = {
    type: MessageType.CARD,
    template_id: templateID,
  };

  if (bodyVariables !== null) {
    payload.body_variables = bodyVariables;
  }

  if (headerVariables !== null) {
    payload.header_variables = headerVariables;
  }

  return request(`${url.whatsapp}/${agentID}/send`, {
    method: 'POST',
    data: {
      customerNumber,
      payload,
    },
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
      'Cache-Control': 'no-cache',
    },
  });
};
